<template>
  <div class="pagination-filter">
    <row>
      <column v-if="hasStringFilter" :xs="columns">
        <field
          type="text"
          icon="search"
          :label="filterLabel"
          :placeholder="placeholder || 'Filter'"
          :value="pagination.filter"
          @update:value="$emit('update:filterString', $event)"/>
      </column>
      <column v-if="hasSort" :xs="columns">
        <field
          v-if="hasSort"
          type="select"
          :value="pagination.sortIndex"
          :options="sortOptions"
          @update:value="$emit('update:sortIndex', $event)"/>
      </column>
      <!--
      <template v-if="queryCount">
        <column v-for="(field, key) in pagination.query" :md="12 / queryCount" :key="key">
          <query-field :field="field"/>
        </column>
      </template>
      -->
    </row>
  </div>
</template>

<script>
// import QueryField from './QueryField'

export default {
  // components: { QueryField },
  props: ['pagination', 'placeholder'],
  computed: {
    columns() {
      return this.hasSort && this.hasStringFilter ? 6 : 12
    },
    hasStringFilter() {
      return this.pagination.filter !== false
    },
    filterLabel() {
      return Object
        .keys(this.pagination.query)
        .filter(filter => filter.label)
        .length
        ? 'Filter'
        : undefined
    },
    hasSort() {
      return this.pagination.sortOptions.length > 1
    },
    sortOptions() {
      return this.pagination.sortOptions.map(({ name }, index) => [index, name])
    },
    // queryCount() {
    //   return Object.keys(this.pagination.query).length + (this.filterExists ? 1 : 0)
    // },
  },
}
</script>

<style lang="scss">
@import '~style/variables';

.pagination-filter {
  padding: 0;
  .field {
    margin-bottom: 0;
    &.with-icon {
      background: $c-info-light;
      border: none;
      input, select {
        background: transparent;
        font-size: $h65;
      }
      > .ic {
        border-right: none;
        color: $c-info-dark;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/PaginationFilter.vue